// @ts-nocheck
/* eslint-disable spire/export-styles */
import { getCookie } from "@insite/client-framework/Common/Cookies";
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
// import { MainNavigationStyles, MappedLink } from "@insite/content-library/Widgets/Header/MainNavigation"; // Starter Custom Code
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridWidths } from "@insite/mobius/GridItem";
// import ChevronDown from "@insite/mobius/Icons/ChevronDown"; // Starter Custom Code
import Link, { StyledIcon } from "@insite/mobius/Link";
// import Menu from "@insite/mobius/Menu"; // Starter Custom Code
import Popover from "@insite/mobius/Popover";
import * as React from "react";
// import { ThemeProps, withTheme } from "styled-components"; // Store Custom Code

/* Starter Custom Code - Start */
// import StyledWrapper from "@insite/client-framework/Common/StyledWrapper"; // Store Custom Code
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
// import { MainNavigationStyles, MappedLink } from "@store/Overrides/Widgets/Header/MainNavigation"; // Store Custom Code
import ChevronDown from "@store/Library/Components/Toolkit/Icons/ChevronDown";
import Menu from "@store/MobiusOverrides/Menu/Menu";
// import { MainNavigationStyles, MappedLink } from "@store/Overrides/Widgets/Header/MainNavigation"; // Store Custom Code
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    currentLocation: getLocation(state),
    defaultImagePath: getSettingsCollection(state).extensionCatalogSettings?.notFoundCategorySmallImagePath, // Store Custom Code
});

const getFilteredChildren = (child: MappedLink, displayChangeCustomerLink: boolean) => {
    return (
        child.children?.filter(children => {
            if (children.excludeFromNavigation) {
                return false;
            }
            if (children.type === "ChangeCustomerPage" && !displayChangeCustomerLink) {
                return false;
            }
            if (children.type === "VmiUsersPage") {
                const currentMode = getCookie(NavigationModeCookieName);
                if (!currentMode || currentMode === "Storefront") {
                    return false;
                }
            }
            return true;
        }) || []
    );
};
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import Typography from "@insite/mobius/Typography";
import { injectCss } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import LazyImage from "@store/MobiusOverrides/LazyImage/LazyImage";
import CaretDown from "@store/Library/Components/Icons/CaretDown";
import SliderBar from "@store/Library/Components/SliderBar";
import {
    MainNavigationStyles,
    MappedLink,
    megaMenuChildrenPadding,
    megaMenuChildrenThumbnailSize,
    popoverPadding,
} from "@store/Overrides/Widgets/Header/MainNavigation";
import parse from "@toolkit/Framework/Common/Utilities/parseFullPageHtml";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import isMobile from "ismobilejs";
import { css, ThemeProps, withTheme } from "styled-components";
import styled from "styled-components";
/* Store Custom Code - End */

interface OwnProps {
    link: MappedLink;
    index: number;
    styles: MainNavigationStyles;
    container: React.RefObject<HTMLElement>;
    isOpen: boolean;
    displayChangeCustomerLink: boolean;
    // Store Custom Code
    onTabChange?: (event: React.MouseEvent | React.KeyboardEvent) => void;
    onLeave?: () => void;
    // useOnHover?: boolean; // KARA
}

type Props = ThemeProps<BaseTheme> & OwnProps & ReturnType<typeof mapStateToProps> /* Starter Custom Code */;

/* Starter Custom Code - Start */
type State = {
    currentTab?: string;
    isCurrentTabOpen?: boolean;
    // Store Custom Code
    canBeOpen: boolean;
    isMobile: boolean;
    shouldRender: boolean;
};
/* Starter Custom Code - End */

/* Store Custom Code - Start */
const MenuStyle = styled.div`
    ${injectCss}
`;

type StyledNavProps = { canBeOpen: boolean; isOpen?: boolean } & InjectableCss;
const StyledNav = styled.nav<StyledNavProps>`
    ${({ canBeOpen }) =>
        canBeOpen &&
        `
    &:focus-within > ${MenuStyle}  /* stylelint-enable */ {
        display: block;
    }
    .trigger:focus + ${MenuStyle},
    &:hover > ${MenuStyle},
    &.focus-within > ${MenuStyle} {
        display: block;
    }`}
    ${injectCss}
`;

const trigger = React.createRef<HTMLElement>();
/* Store Custom Code - End */

class MainNavigationItem extends React.Component<Props, State /* Store Custom Code */> {
    /* Starter Custom Code - Start */
    menuWrapperRef = React.createRef<HTMLElement>(); // Store Custom Code
    firstTabKey: string | undefined = undefined;

    constructor(props: Props) {
        super(props);

        this.state = {
            currentTab: undefined,
            isCurrentTabOpen: false,
            // Store Custom Code
            canBeOpen: true,
            isMobile: false,
            shouldRender: true,
        };
    }

    popoverWrapper = React.createRef<HTMLDivElement>();
    /* Starter Custom Code - End */
    /* Store Custom Code - Start */
    componentDidMount() {
        this.setState({
            isMobile: isMobile().any,
        });

        window.addEventListener("resize", this.verifyIsMobile);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.verifyIsMobile);
    }

    verifyIsMobile = () => {
        window.setTimeout(() => {
            this.setState({
                isMobile: isMobile().any,
            });
        }, 50);
    };
    /* Store Custom Code - End */
    element = React.createRef<HTMLElement>();
    popover = React.createRef<any>();

    componentDidUpdate(prevProps: Readonly<Props>) {
        /* Starter Custom Code - Start */
        if (!this.firstTabKey) {
            this.initNav();
        }
        /* Starter Custom Code - End */
        if (this.props.isOpen && !prevProps.isOpen) {
            this.openPopover();
        } else if (!this.props.isOpen && prevProps.isOpen) {
            this.closePopover();
        }
    }

    closePopover = () => {
        this.popover.current && (this.popover.current! as any).closePopover();
    };

    openPopover = () => {
        this.popover.current && (this.popover.current! as any).openPopover();
    };

    /* Starter Custom Code - Start */
    initNav = () => {
        const firstChild = this.props.link?.children?.filter(child => !child.excludeFromNavigation)[0];
        const tabKey = firstChild?.title;

        if (tabKey) {
            this.firstTabKey = tabKey;
            this.setState({ currentTab: tabKey, isCurrentTabOpen: true });
        }
    };

    changeTab = (tabKey: string) => {
        if (tabKey === this.state.currentTab) {
            this.setState({ currentTab: tabKey, isCurrentTabOpen: !this.state.isCurrentTabOpen });
        } else {
            this.setState({ currentTab: tabKey, isCurrentTabOpen: true });
        }
    };

    handleMouseLeave = (event: React.MouseEvent) => {
        const relatedTarget = event.relatedTarget as Node | null;
        if (this.popoverWrapper.current?.contains(relatedTarget)) {
            return;
        }
        this.closePopover();
    };
    /* Starter Custom Code - End */

    /* Store Custom Code - Start */
    onOpenMegaMenu = () => {
        this.initNav();
    };
    closeOnHoverMenu = () => {
        // On Mobile, the below logic
        // where we switch the canBeOpen state from false to true
        // causes the mobile experience to not function well
        // due to Mobile not doing hover functionality

        // Solution:
        // I prevent the boolean toggle when we detect mobile

        this.setState({ canBeOpen: this.state.isMobile }, () =>
            setTimeout(() => {
                // The make the all browsers act the same on item click.
                if (document.activeElement instanceof HTMLElement) {
                    document.activeElement.blur();
                }
                this.setState({ canBeOpen: true });
            }, 100),
        );

        this.props.onLeave?.();

        // closeOnHoverMenuWithoutChildren = (hasMenuChildren?: boolean) => {
        // This is for high resolution mobile users.
        // So that the menu closes on nav items without children
        this.setState(
            {
                shouldRender: false,
            },
            () => {
                this.setState({ shouldRender: true });
            },
        );
    };

    menuWrapperMouseLeaveHandler = () => {
        if (!this.menuWrapperRef.current) {
            return;
        }

        this.menuWrapperRef.current.blur();

        const menuTrigger = this.menuWrapperRef.current.children[0] as HTMLElement;
        if (!menuTrigger) {
            return;
        }
        menuTrigger.blur();
        this.closeOnHoverMenu();
        this.props.onLeave?.();
    };
    /* Store Custom Code - End */

    render() {
        const {
            styles,
            link,
            index,
            isOpen,
            theme: {
                breakpoints: { maxWidths },
            },
            // Store Custom Code
            // useOnHover, // KARA
        } = this.props;
        const downIcon = <StyledIcon src={CaretDown} {...styles.menuItemIcon} />; // Store Custom Code
        const hasChildren = link.children && link.children.filter(child => !child.excludeFromNavigation).length > 0;
        const isCascading =
            hasChildren && (link.childrenType === "CascadingMenu" || link.childrenType === "CustomLinkList");
        /* Starter Custom Code - Start */
        const isMega = hasChildren && link.childrenType === "MegaMenu" && !link.isMegaMenuWithTabs;
        const isMegaWithTabs = hasChildren && link.childrenType === "MegaMenu" && link.isMegaMenuWithTabs;
        const maxChild = link.maxChild ?? 99;
        const maxChildren = link.maxChildren ?? 3;
        const maxGrandChildren = link.maxGrandChildren ?? 3;
        const { currentTab, isCurrentTabOpen } = this.state;
        const isCustomMega = link.customMegaMenu; // Store Custom Code
        const useOnHover = link.useOnHover;
        /* Starter Custom Code - End */

        let menuLink = (
            <Link
                className="menu-item"
                typographyProps={styles.menuItemTypography}
                color={styles.menuItemTypography?.color}
                {...styles.menuItem}
                href={isCascading && !useOnHover ? undefined : link.url} // Starter Custom Code
                target={link.url ? (link.openInNewWindow ? "_blank" : "_self") : undefined} // Starter Custom Code
                aria-haspopup={isCascading} // Starter Custom Code
                aria-expanded={isOpen} // Starter Custom Code
            >
                {link.title}
                {isCascading && downIcon}
            </Link>
        );
        if (isMega || link.url === "" || isMegaWithTabs /* Starter Custom Code */) {
            menuLink = (
                <Link
                    className="menu-item"
                    typographyProps={styles.menuItemTypography}
                    onClick={() => {}} // Starter Custom Code - Ensure the link will always be a "button"
                    onMouseEnter={useOnHover ? this.openPopover : undefined} // Starter Custom Code
                    onMouseLeave={useOnHover ? this.handleMouseLeave : undefined} // Starter Custom Code
                    onFocus={useOnHover ? this.openPopover : undefined} // Starter Custom Code
                    /* Starter Removed - color */
                    {...styles.menuItem}
                >
                    {link.title}
                    {/* Store Removed - downIcon */}
                </Link>
            );
        }

        let menuItem = menuLink;

        if (isCascading && link.children) {
            const menuProps: { maxDepth?: number } = {};
            if (link.maxDepth) {
                menuProps.maxDepth = link.maxDepth;
            }
            /* Starter Custom Code - Start */
            const menuItemsArray =
                link.url && !useOnHover
                    ? [
                          {
                              ...link,
                              title: `${translate("View")} ${link.title}`,
                              children: undefined,
                              isViewAll: true,
                          },
                          ...link.children,
                      ]
                    : link.children;
            /* Starter Custom Code - End */

            menuItem = (
                <Menu
                    className="cascading-menu"
                    data-test-selector={`mainNavigationItem_${index}`}
                    isOpen={isOpen || undefined}
                    descriptionId={`${link.title}_${index}`}
                    menuItems={menuItemsArray} // Starter Custom Code
                    menuTrigger={menuLink}
                    displayChangeCustomerLink={this.props.displayChangeCustomerLink}
                    useOnHover={useOnHover} // Starter Custom Code
                    width={250} // Starter Custom Code
                    {...menuProps}
                    {...styles.cascadingMenu}
                />
            );
        }

        /* Store Custom Code - Start */
        if (isMega || isCustomMega) {
            let altMegaMenuImg = {
                css: css``,
            };

            if (isCustomMega && link.megaMenuImage !== "" && link.megaMenuImage !== undefined) {
                altMegaMenuImg = {
                    css: css`
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 100%;
                        min-height: ${pxToRem(290)};
                        background-image: url(${link.megaMenuImage});
                        background-size: cover;
                        background-position: center;
                        text-align: center;
                    `,
                };
            }

            const menuItemContent = (
                <MenuStyle
                    {...(useOnHover
                        ? styles.megaMenuContentWrapperOnHover
                        : styles.megaMenuContentWrapper)} /* Starter Custom Code */
                >
                    {isCustomMega && (
                        <GridContainer
                            className="mega-menu-grid-container"
                            data-test-selector={`mainNavigationItem_${index}`}
                            {...styles.megaMenuGridContainer}
                            offsetProps={{ ...styles.megaMenuGridContainer?.offsetProps, as: "ul" }}
                        >
                            <GridItem
                                className="mega-menu-grid-item"
                                width={5}
                                // eslint-disable-next-line react/no-array-index-key
                                key={index}
                                {...styles.megaMenuGridItemCustomMega}
                                as="li"
                            >
                                <StyledWrapper {...altMegaMenuImg}>
                                    <StyledWrapper>
                                        {link.megaMenuText && link.megaMenuText !== "" ? (
                                            <Typography {...styles.megaMenuText}>
                                                {parse(link.megaMenuText, parserOptions)}
                                            </Typography>
                                        ) : null}
                                        {link.megaMenuImageLink && link.megaMenuImageLinkLabel !== "" && (
                                            <Link
                                                onClick={this.closePopover}
                                                href={link.megaMenuImageLink.value}
                                                {...styles.megaMenuImageLink}
                                            >
                                                {link.megaMenuImageLinkLabel}
                                            </Link>
                                        )}
                                    </StyledWrapper>
                                </StyledWrapper>
                            </GridItem>

                            {link
                                .children!.filter(child => !child.excludeFromNavigation)
                                .slice(0, maxChild) // maxChild limited to two for the top level custom links
                                .map((child, index) => (
                                    <GridItem
                                        className="mega-menu-grid-item"
                                        width={3}
                                        // eslint-disable-next-line react/no-array-index-key
                                        key={index}
                                        {...styles.altMegaMenuChildren}
                                        as="li"
                                    >
                                        {child.title !== "" && (
                                            <Typography {...styles.altMegaMenuTitle}>{child.title}</Typography>
                                        )}

                                        {index === 1 && link.columnText && link.columnText !== undefined ? (
                                            <StyledWrapper {...styles.columnText}>
                                                {parse(link.columnText, parserOptions)}
                                            </StyledWrapper>
                                        ) : (
                                            child.children &&
                                            child.children.length > 0 && (
                                                <StyledWrapper as="ul" data-test-selector={`linksFor_${child.title}`}>
                                                    {child.children
                                                        .filter(grandChild => {
                                                            if (!grandChild) {
                                                                // Store Custom Code - Prevents CMS Error
                                                                return false;
                                                            }
                                                            if (grandChild.excludeFromNavigation) {
                                                                return false;
                                                            }

                                                            if (
                                                                grandChild.type === "ChangeCustomerPage" &&
                                                                !this.props.displayChangeCustomerLink
                                                            ) {
                                                                return false;
                                                            }
                                                            if (grandChild.type === "VmiUsersPage") {
                                                                const currentMode = getCookie(NavigationModeCookieName);
                                                                if (!currentMode || currentMode === "Storefront") {
                                                                    return false;
                                                                }
                                                            }
                                                            return true;
                                                        })
                                                        .slice(0, maxChildren)
                                                        .map((grandChild, index) => {
                                                            return (
                                                                <li key={index}>
                                                                    <Link
                                                                        className="mega-menu-link"
                                                                        {...styles.megaMenuLink}
                                                                        onClick={this.closePopover}
                                                                        href={grandChild.url}
                                                                        data-test-selector={grandChild.title}
                                                                        target={
                                                                            grandChild.openInNewWindow
                                                                                ? "_blank"
                                                                                : "_self"
                                                                        }
                                                                    >
                                                                        <SliderBar>{grandChild.title}</SliderBar>
                                                                    </Link>
                                                                </li>
                                                            );
                                                        })}
                                                </StyledWrapper>
                                            )
                                        )}
                                    </GridItem>
                                ))}
                        </GridContainer>
                    )}

                    {!isCustomMega /* Store Custom Code */ && (
                        <>
                            {(() => {
                                const firstLevelLinks = link.children!.filter(child => !child.excludeFromNavigation);
                                const maxGrandChilds = Math.min(
                                    firstLevelLinks.reduce((prev, curr) =>
                                        !prev || !prev.children
                                            ? curr
                                            : curr.children
                                              ? curr.children?.length > prev.children?.length
                                                  ? curr
                                                  : prev
                                              : prev,
                                    ).children?.length || 0,
                                    maxChildren,
                                );
                                const minHeight =
                                    (Math.ceil(maxGrandChilds / 2) + 1) *
                                        (megaMenuChildrenThumbnailSize + megaMenuChildrenPadding) -
                                    megaMenuChildrenPadding +
                                    popoverPadding * 1.5; // 1.5 because the ul is not at the top; it's first li has a margin-top of half the popoverPadding

                                return (
                                    <StyledWrapper
                                        as="ul"
                                        {...styles.megaMenuList}
                                        css={css`
                                            min-height: ${minHeight}px;
                                        `}
                                    >
                                        {link
                                            .children!.filter(child => !child.excludeFromNavigation)
                                            .slice(0, maxChild + 1) // Starter Custom Code
                                            .map((child, index) => {
                                                const tabKey = child.title;
                                                return (
                                                    <StyledWrapper
                                                        className="mega-menu-grid-item"
                                                        width={12}
                                                        // eslint-disable-next-line react/no-array-index-key
                                                        key={index}
                                                        {...styles.megaMenuGridItem}
                                                        as="li"
                                                    >
                                                        {/* Store Moved - mega-menu-heading-link - down */}
                                                        <nav>
                                                            <Link
                                                                className="mega-menu-heading-button"
                                                                {...styles.megaMenuHeadingLink}
                                                                onClick={event => this.changeTab(tabKey)}
                                                                onMouseOver={
                                                                    useOnHover
                                                                        ? event => this.changeTab(tabKey)
                                                                        : undefined
                                                                }
                                                                key={`content-${tabKey}`}
                                                                aria-haspopup="true"
                                                                aria-expanded={
                                                                    tabKey === currentTab && isCurrentTabOpen
                                                                }
                                                                data-is-open={tabKey === currentTab}
                                                            >
                                                                <SliderBar>{child.title}</SliderBar>
                                                            </Link>
                                                            {/* Starter Custom Code */}
                                                            {tabKey === currentTab &&
                                                                child.children &&
                                                                child.children.length > 0 && (
                                                                    <GridContainer
                                                                        {...styles.megaMenuChildren}
                                                                        data-test-selector={`linksFor_${child.title}`}
                                                                        offsetProps={{
                                                                            ...styles.megaMenuChildren?.offsetProps,
                                                                            as: "ul",
                                                                        }}
                                                                    >
                                                                        {child.children
                                                                            .filter(grandChild => {
                                                                                if (grandChild.excludeFromNavigation) {
                                                                                    return false;
                                                                                }

                                                                                if (
                                                                                    grandChild.type ===
                                                                                        "ChangeCustomerPage" &&
                                                                                    !this.props
                                                                                        .displayChangeCustomerLink
                                                                                ) {
                                                                                    return false;
                                                                                }
                                                                                if (
                                                                                    grandChild.type === "VmiUsersPage"
                                                                                ) {
                                                                                    const currentMode =
                                                                                        getCookie(
                                                                                            NavigationModeCookieName,
                                                                                        );
                                                                                    if (
                                                                                        !currentMode ||
                                                                                        currentMode === "Storefront"
                                                                                    ) {
                                                                                        return false;
                                                                                    }
                                                                                }
                                                                                return true;
                                                                            })
                                                                            .slice(0, maxChildren + 1) // Starter Custom Code - Voluntarily keep one more item to show the see all button
                                                                            .map((grandChild, index) => {
                                                                                /* Starter Custom Code */
                                                                                const imagePath =
                                                                                    grandChild.smallImagePath ||
                                                                                    this.props.defaultImagePath;

                                                                                return index >= maxChildren ? (
                                                                                    // eslint-disable-next-line react/no-array-index-key
                                                                                    <GridItem
                                                                                        as="li"
                                                                                        {...styles.subCategorySeeAll}
                                                                                        key={index}
                                                                                    >
                                                                                        <Link
                                                                                            className="mega-menu-more-link"
                                                                                            {...styles.megaMenuSeeMoreLink}
                                                                                            onClick={this.closePopover}
                                                                                            href={child.url}
                                                                                            tabIndex={
                                                                                                isCurrentTabOpen
                                                                                                    ? 0
                                                                                                    : -1
                                                                                            }
                                                                                        >
                                                                                            <SliderBar>
                                                                                                {translate(
                                                                                                    "See all Categories",
                                                                                                    child.children?.length.toString() ||
                                                                                                        "",
                                                                                                )}
                                                                                            </SliderBar>
                                                                                        </Link>
                                                                                    </GridItem>
                                                                                ) : (
                                                                                    // eslint-disable-next-line react/no-array-index-key
                                                                                    <GridItem
                                                                                        as="li"
                                                                                        {...styles.subCategory}
                                                                                        key={index}
                                                                                    >
                                                                                        <Link
                                                                                            className="mega-menu-link"
                                                                                            {...styles.megaMenuLink}
                                                                                            onClick={this.closePopover}
                                                                                            href={grandChild.url}
                                                                                            data-test-selector={
                                                                                                grandChild.title
                                                                                            }
                                                                                            tabIndex={
                                                                                                isCurrentTabOpen
                                                                                                    ? 0
                                                                                                    : -1
                                                                                            }
                                                                                        >
                                                                                            {grandChild.subCategory && (
                                                                                                <LazyImage
                                                                                                    {...styles.megaMenuSubCategoryImg}
                                                                                                    src={imagePath}
                                                                                                    altText={
                                                                                                        grandChild.title
                                                                                                    }
                                                                                                />
                                                                                            )}
                                                                                            <SliderBar>
                                                                                                {grandChild.title}
                                                                                            </SliderBar>
                                                                                        </Link>
                                                                                    </GridItem>
                                                                                );
                                                                                /* Starter Custom Code */
                                                                            })}
                                                                    </GridContainer>
                                                                )}
                                                        </nav>
                                                    </StyledWrapper>
                                                );
                                            })}
                                        {/* Starter Custom Code - Start */}
                                        {this.props.link.url && !isCustomMega && (
                                            <GridItem width={12} as="li">
                                                <Link
                                                    {...styles.megaMenuViewAllLink}
                                                    onClick={this.closePopover}
                                                    href={this.props.link.url}
                                                >
                                                    {translate("View All")} {this.props.link.title}
                                                </Link>
                                            </GridItem>
                                        )}
                                        {/* Starter Custom Code - End */}
                                    </StyledWrapper>
                                );
                            })()}
                        </>
                    )}
                </MenuStyle>
            );

            const descriptionId = uniqueId();
            menuItem = useOnHover ? (
                <>
                    <StyledNav
                        ref={this.menuWrapperRef}
                        {...styles.megaMenuNav}
                        isOpen={isOpen}
                        canBeOpen={this.state.canBeOpen}
                        onMouseLeave={this.menuWrapperMouseLeaveHandler}
                        data-test-selector="styledNav"
                        {...{ "aria-labelledby": descriptionId }}
                    >
                        {React.cloneElement(menuLink, { id: descriptionId, className: "trigger menu-item" })}
                        {this.state.shouldRender && menuItemContent}
                    </StyledNav>
                    <span ref={trigger} tabIndex={-1} />
                </>
            ) : (
                <Popover
                    className="mega-menu"
                    zIndexKey="menu"
                    {...styles.megaMenu}
                    contentBodyProps={{
                        ...styles.megaMenu?.contentBodyProps,
                        /* Starter Removed - _width */
                        as: "div",
                    }}
                    controlsId={`${index}_${link.title}`}
                    ref={this.popover}
                    positionFunction={(element: React.RefObject<HTMLUListElement>) => {
                        return { position: "fixed" }; // Starter Custom Code
                    }}
                    popoverTrigger={menuLink}
                    insideRefs={[this.element]}
                    onOpen={this.onOpenMegaMenu}
                >
                    {menuItemContent}
                </Popover>
            );
        }
        /* Store Custom Code - End */

        /* Starter Custom Code - Start */
        if (isMegaWithTabs) {
            const child = link.children!.filter(child => !child.excludeFromNavigation);
            menuItem = (
                <Popover
                    className="mega-menu"
                    zIndexKey="menu"
                    {...styles.megaMenu}
                    contentBodyProps={{
                        ...styles.megaMenuWithTabs?.contentBodyProps,
                        as: "div",
                    }}
                    controlsId={`${index}_${link.title}`}
                    ref={this.popover}
                    positionFunction={() => ({ position: "fixed" })}
                    popoverTrigger={menuLink}
                    insideRefs={[this.element]}
                    onOpen={this.initNav}
                >
                    <StyledWrapper {...styles.megaMenuWithTabsContentWrapper}>
                        <StyledWrapper {...styles.megaMenuWithTabsWrapper} as="ul">
                            {child.slice(0, maxChild).map((child, index) => {
                                const tabKey = child.title;
                                const id = child.title.replace(/\W/g, "-").toLowerCase();
                                const hasChildren = Boolean(child.children?.some(x => !x.excludeFromNavigation));
                                return (
                                    <StyledWrapper as="li" key={child.title} {...styles.megaMenuWithTabsMainChild}>
                                        <Link
                                            {...(tabKey === currentTab || hasChildren
                                                ? styles.megaMenuWithTabsMainChildWithSubmenuLink
                                                : styles.megaMenuWithTabsMainChildLink)}
                                            href={!hasChildren ? child.url : undefined}
                                            onClick={
                                                tabKey === currentTab || hasChildren
                                                    ? () => this.changeTab(tabKey)
                                                    : this.closePopover
                                            }
                                            aria-haspopup={tabKey === currentTab || hasChildren}
                                            aria-controls={id}
                                            aria-expanded={tabKey === currentTab}
                                            aria-current={
                                                this.props.currentLocation.pathname === child.url ? "page" : undefined
                                            }
                                        >
                                            {child.title}
                                        </Link>

                                        {tabKey === currentTab && (
                                            <GridContainer
                                                id={id}
                                                role="menu"
                                                className="mega-menu-grid-container"
                                                data-test-selector={`mainNavigationItem_${index}`}
                                                {...styles.megaMenuWithTabsGridContainer}
                                                offsetProps={{
                                                    ...styles.megaMenuWithTabsGridContainer?.offsetProps,
                                                    as: "ul",
                                                }}
                                            >
                                                {getFilteredChildren(child, this.props.displayChangeCustomerLink)
                                                    .slice(0, maxChildren)
                                                    .map(children => (
                                                        <GridItem
                                                            className="mega-menu-grid-item"
                                                            width={(12 / link.numberOfColumns!) as GridWidths}
                                                            // eslint-disable-next-line react/no-array-index-key
                                                            key={index}
                                                            {...styles.megaMenuGridItem}
                                                        >
                                                            <Link
                                                                className="mega-menu-heading-link"
                                                                {...styles.megaMenuHeading}
                                                                href={children.url}
                                                                onClick={this.closePopover}
                                                                tabIndex={isCurrentTabOpen ? 0 : -1}
                                                                aria-current={
                                                                    this.props.currentLocation.pathname === children.url
                                                                        ? "page"
                                                                        : undefined
                                                                }
                                                            >
                                                                {children.title}
                                                            </Link>
                                                            {children.children && children.children.length > 0 && (
                                                                <StyledWrapper
                                                                    as="ul"
                                                                    {...styles.megaMenuChildren}
                                                                    data-test-selector={`linksFor_${child.title}`}
                                                                >
                                                                    {getFilteredChildren(
                                                                        children,
                                                                        this.props.displayChangeCustomerLink,
                                                                    )
                                                                        .slice(0, maxGrandChildren + 1)
                                                                        .map((grandChildren, index) => {
                                                                            return index >= maxGrandChildren ? (
                                                                                <li key={grandChildren.title}>
                                                                                    <Link
                                                                                        className="mega-menu-more-link"
                                                                                        {...styles.megaMenuSeeMoreLink}
                                                                                        onClick={this.closePopover}
                                                                                        href={children.url}
                                                                                        tabIndex={
                                                                                            isCurrentTabOpen ? 0 : -1
                                                                                        }
                                                                                        aria-current={
                                                                                            this.props.currentLocation
                                                                                                .pathname ===
                                                                                            children.url
                                                                                                ? "page"
                                                                                                : undefined
                                                                                        }
                                                                                    >
                                                                                        {translate(
                                                                                            "See all ({0})",
                                                                                            children.children?.length.toString() ||
                                                                                                "",
                                                                                        )}
                                                                                    </Link>
                                                                                </li>
                                                                            ) : (
                                                                                <li key={grandChildren.title}>
                                                                                    <Link
                                                                                        className="mega-menu-link"
                                                                                        {...styles.megaMenuLink}
                                                                                        onClick={this.closePopover}
                                                                                        href={grandChildren.url}
                                                                                        data-test-selector={
                                                                                            grandChildren.title
                                                                                        }
                                                                                        tabIndex={
                                                                                            isCurrentTabOpen ? 0 : -1
                                                                                        }
                                                                                        aria-current={
                                                                                            this.props.currentLocation
                                                                                                .pathname ===
                                                                                            grandChildren.url
                                                                                                ? "page"
                                                                                                : undefined
                                                                                        }
                                                                                    >
                                                                                        {grandChildren.title}
                                                                                    </Link>
                                                                                </li>
                                                                            );
                                                                        })}
                                                                </StyledWrapper>
                                                            )}
                                                        </GridItem>
                                                    ))}
                                                <GridItem width={12} {...styles.megaMenuGridItem}>
                                                    <Link
                                                        {...styles.megaMenuViewAllLink}
                                                        onClick={this.closePopover}
                                                        href={child.url}
                                                        tabIndex={isCurrentTabOpen ? 0 : -1}
                                                        aria-current={
                                                            this.props.currentLocation.pathname === child.url
                                                                ? "page"
                                                                : undefined
                                                        }
                                                    >
                                                        {translate("See all {0}", child.title || "")}
                                                    </Link>
                                                </GridItem>
                                            </GridContainer>
                                        )}
                                    </StyledWrapper>
                                );
                            })}
                            {this.props.link.url && maxChild < child.length && (
                                <StyledWrapper as="li" {...styles.megaMenuWithTabsViewAllWrapper}>
                                    <Link
                                        {...styles.megaMenuWithTabsViewAllLink}
                                        onClick={this.closePopover}
                                        href={this.props.link.url}
                                    >
                                        {translate("View All")} {this.props.link.title}
                                    </Link>
                                </StyledWrapper>
                            )}
                        </StyledWrapper>
                    </StyledWrapper>
                </Popover>
            );
        }
        /* Starter Custom Code - End */

        return menuItem;
    }
}

export default connect(mapStateToProps)(withTheme(MainNavigationItem)) /* Starter Custom Code */;
